/** @jsxImportSource @emotion/react */
import APIClient from 'APIClient';
import { css } from '@emotion/react';
import { useState, useEffect } from 'react';

import Text from 'components/Text';
import handleError from 'utils/handleError';
import { campaignCategoriesEmojies } from 'constants';
import { BLACK, WHITE, PURPLE_LIGHT } from 'styles/colors';

const styles = css`
  .badge-category {
    padding: 6px 12px;
    margin-right: 8px;
    width: fit-content;
    border-radius: 30px;
    border: 1px solid ${WHITE};
  }

  .badge-category-lg {
    margin-left: 40px;
    padding: 20px 50px;
    width: fit-content;
    border-radius: 85px;
    background-color: ${PURPLE_LIGHT};
  }
  .badge-category-carousel {
    display: flex;
    overflow: hidden;
    user-select: none;
    margin-bottom: 40px;
  }

  .badge-category-carousel-container {
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
    min-width: 100%;
    animation: scroll 40s linear infinite;
  }

  .badge-category-carousel:first-child {
    margin-top: 40px;
  }
  .badge-category-carousel-container.reverse {
    animation: scrollReverse 52s linear infinite;
  }

  .badge-category-carousel:first-child {
    margin-top: 140px;
  }
`;

export const FeekCategory = () => {
  const [categoriesMarqueeOne, setCategoriesMarqueeOne] = useState(
    [],
  );
  const [categoriesMarqueeTwo, setCategoriesMarqueeTwo] = useState(
    [],
  );

  useEffect(() => {
    APIClient.getCategoriesLanding()
      .then(({ data }) => {
        //first half
        setCategoriesMarqueeOne(data.slice(0, data?.length / 2));
        //second half
        setCategoriesMarqueeTwo(data.slice(data?.length / 2));
      })
      .catch(handleError);
  }, []);

  return (
    <div css={styles} className="section px-0">
      <div className="badge-category-carousel">
        <div className="badge-category-carousel-container">
          {categoriesMarqueeOne.map((category, index) => (
            <div
              className="badge-category-lg"
              key={category._id + index || index}
            >
              <Text color={BLACK} fontSize={55} lineHeight={89}>
                {campaignCategoriesEmojies[category.key] || '✨'}{' '}
                {category.name}
              </Text>
            </div>
          ))}
        </div>
        <div
          className="badge-category-carousel-container"
          aria-hidden="true"
        >
          {categoriesMarqueeOne.map((category, index) => (
            <div
              className="badge-category-lg"
              key={category._id + index || index}
            >
              <Text color={BLACK} fontSize={55} lineHeight={89}>
                {campaignCategoriesEmojies[category.key] || '✨'}{' '}
                {category.name}
              </Text>
            </div>
          ))}
        </div>
      </div>
      <div className="badge-category-carousel">
        <div className="badge-category-carousel-container reverse">
          {categoriesMarqueeTwo.map((category, index) => (
            <div
              className="badge-category-lg"
              key={category._id + index || index}
            >
              <Text color={BLACK} fontSize={55} lineHeight={89}>
                {campaignCategoriesEmojies[category.key] || '✨'}{' '}
                {category.name}
              </Text>
            </div>
          ))}
        </div>
        <div
          className="badge-category-carousel-container reverse"
          aria-hidden="true"
        >
          {categoriesMarqueeTwo.map((category, index) => (
            <div
              className="badge-category-lg"
              key={category._id + index || index}
            >
              <Text color={BLACK} fontSize={55} lineHeight={89}>
                {campaignCategoriesEmojies[category.key] || '✨'}{' '}
                {category.name}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
